"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRELOAD_CONFIG = exports.FontPreload = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["weights", "language"];
// TODO: we are figuring out the best way of delivering this from Foundation
// While these URLs rarly change, we have a test case in index.test.tsx that
// ensures these are kept in sync with our font.css file.
var PRELOAD_CONFIG = exports.PRELOAD_CONFIG = {
  latin: {
    regular: ['https://encore.scdn.co/fonts/SpotifyMixUI-Regular-cc3b1de388efa4cbca6c75cebc24585e.woff2'],
    bold: ['https://encore.scdn.co/fonts/SpotifyMixUITitleVariable-8769ccfde3379b7ebcadd9529b49d0cc.woff2', 'https://encore.scdn.co/fonts/SpotifyMixUITitle-Bold-37290f1de77f297fcc26d71e9afcf43f.woff2', 'https://encore.scdn.co/fonts/SpotifyMixUI-Bold-4264b799009b1db5c491778b1bc8e5b7.woff2'],
    extrabold: ['https://encore.scdn.co/fonts/SpotifyMixUITitleVariable-8769ccfde3379b7ebcadd9529b49d0cc.woff2', 'https://encore.scdn.co/fonts/SpotifyMixUITitle-Extrabold-ba6c73cd7f82c81e49cf2204017803ed.woff2']
  },
  arabic: {
    regular: ['https://encore.scdn.co/fonts/CircularSp-Arab-Book-8c0cff2514cf52ffcc4976fa813c4712.woff2'],
    bold: ['https://encore.scdn.co/fonts/CircularSp-Arab-Bold-c638a17a6708a3bd51bd2422c3fedcfb.woff2'],
    extrabold: ['https://encore.scdn.co/fonts/CircularSp-Arab-Black-14419efc36612ec0a627c8ad1e7ae3cf.woff2']
  },
  devanagari: {
    regular: ['https://encore.scdn.co/fonts/CircularSp-Deva-Book-adf5439f4c3e684fd5dd69f64d659efc.woff2'],
    bold: ['https://encore.scdn.co/fonts/CircularSp-Deva-Bold-b2a990e06d50b37c1516c3d140496934.woff2'],
    extrabold: ['https://encore.scdn.co/fonts/CircularSp-Deva-Black-409aaab18f0fc439f0658d5556df302b.woff2']
  },
  cyrillic: {
    regular: ['https://encore.scdn.co/fonts/CircularSp-Cyrl-Book-cc791a2e69e25c0440792bd855600ca7.woff2'],
    bold: ['https://encore.scdn.co/fonts/CircularSp-Cyrl-Bold-180db050d109afeef4331b1ee551c349.woff2'],
    extrabold: ['https://encore.scdn.co/fonts/CircularSp-Cyrl-Black-1ce6672693e92d2cb1d04af1690e1f9c.woff2']
  },
  hebrew: {
    regular: ['https://encore.scdn.co/fonts/CircularSp-Hebr-Book-414f88babad55bb44c9552d9b92504f7.woff2'],
    bold: ['https://encore.scdn.co/fonts/CircularSp-Hebr-Bold-9b609e9268a3f9d73732dc3cc375821e.woff2'],
    extrabold: ['https://encore.scdn.co/fonts/CircularSp-Hebr-Black-29a8af6f5782cdf3009a5ac966ee4fa6.woff2']
  },
  greek: {
    regular: ['https://encore.scdn.co/fonts/CircularSp-Grek-Book-5d5a3a10aa26b63a2575ce872ad43f07.woff2'],
    bold: ['https://encore.scdn.co/fonts/CircularSp-Grek-Bold-fafb1410c85fe7e6e81c68e609d4b823.woff2'],
    extrabold: ['https://encore.scdn.co/fonts/CircularSp-Grek-Black-b45055a950eac7560342cb7fa07559ad.woff2']
  }
};
/**
 * Preload the fonts used in Encore's fonts.css file.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-fontpreload--docs) |
 * [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FontPreload)
 *
 * @example
 * // Preloads all weights of latin by default
 * <FontPreload />
 *
 * // For more specific needs, you can specify the languages and weights needed
 * <FontPreload language="arabic" weights={["book", "bold"]} />
 */
var FontPreload = exports.FontPreload = function FontPreload(_ref) {
  var _ref$weights = _ref.weights,
    weights = _ref$weights === void 0 ? ['regular', 'bold', 'extrabold'] : _ref$weights,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'latin' : _ref$language,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var urls = weights.flatMap(function (weight) {
    return PRELOAD_CONFIG[language][weight];
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, urls.map(function (url) {
    return /*#__PURE__*/_react["default"].createElement("link", Object.assign({
      rel: "preload",
      key: url,
      href: url,
      as: "font",
      type: "font/woff2",
      crossOrigin: "anonymous"
    }, props));
  }));
};